import React from 'react';

import { useThrottle } from '@core/dashboard/hooks/helpers';

interface IEmojiItem {
  src: string;
  onClick: () => void;
}

const EmojiItem = ({ src, onClick }: IEmojiItem) => {
  const handleClick = useThrottle(onClick);

  return <img src={src} alt="Emoji" onClick={handleClick} />;
};

export default EmojiItem;
